import * as React from 'react';
import { createApiClient, ApiClient } from '../../../services/ApiClient';
import { Modal, ModalTitle, Button} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { isEmpty } from 'lodash';


interface NotifiItem {
    id: string;
    createTime: string;
    value: string;
    status: string;
}

interface State {
    form: string;
    values: number;
    items: Array<NotifiItem>;
    show: boolean;
}

class NotifyModal extends React.Component<{}, State>{
    constructor() {
        super();
        this.state = {
            form: "",
            values: 0,
            items: [],
            show: false
        }
        this.handleClose = this.handleClose.bind(this);
        this.onEnter = this.onEnter.bind(this);
    }

    handleClose() {
        this.setState({ show: false })
    }

    public show(form: string, values: number) {
        this.setState({
            form,
            values,
            show: true
        })
    }

    onEnter(){
        const client = createApiClient();
        const { form, values } = this.state;

        client.getNotify(form,values,{
            success: (data) =>{
                this.setState({ items: data });
            }
        });
    }

    render() {
        const config ={
            height: '310px',
            options: {
                noDataText: 'У вас пока нет уведомлений',
            }
        }
        const formate = (cell, row) =>{
            return (<span style={{whiteSpace:"pre-line"}}>{cell}</span>)
        }

        const formateStatus = (cell, row) =>{
            const { form, values } = this.state;
            const api = createApiClient()
            const url = api.getAttachFileUrl(form, values, row.id);

            return !isEmpty(row.filename) ? (
                <span style={{whiteSpace:"pre-line"}}>
                    {cell}<br/>
                    <a className="btn-link" href={url}>Скачать</a>
                </span>
            ) : (<span style={{whiteSpace:"pre-line"}}>{cell}</span>)
        }

        const html = (cell, row) =>{
            return <div style={{whiteSpace:"pre-line"}} dangerouslySetInnerHTML={{__html:cell}}></div>
        }

        return (
            <Modal onEnter={this.onEnter}  bsSize="large" show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Уведомления</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <BootstrapTable {...config} data={this.state.items} >
                        <TableHeaderColumn dataField='id' isKey={true} hidden></TableHeaderColumn>
                        <TableHeaderColumn dataField='filename' hidden></TableHeaderColumn>
                        <TableHeaderColumn dataField='createTime' dataSort width="150px" dataFormat={formate}>Дата создания</TableHeaderColumn>
                        <TableHeaderColumn dataField='status' dataSort width="150px" dataFormat={formateStatus}>Статус</TableHeaderColumn>
                        <TableHeaderColumn dataField='value' dataFormat={html}>Уведомление</TableHeaderColumn>
                   </BootstrapTable>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleClose}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default NotifyModal;



// WEBPACK FOOTER //
// ./src/components/program/notify/index.tsx